<template>
  <div class="inventario-panel-row">
    <h4 class="inventario-panel-subtitle">{{ row.name }}</h4>

    <CDataTable
      hover
      bordered
      small
      fixed
      :loading="isLoading"
      :items="items"
      :fields="fields"
    >
      <template #over-table>
        <CRow class=""> </CRow>
      </template>

      <template #folio-header>
        <div class="d-flex flex-row">
          <span class="align-self-center">Folio</span>
        </div>
      </template>

      <template #folio="{item}">
        <td class="py-2">
          {{ item.folio }}
        </td>
      </template>
      <template #ubicacion_raiz_id="{item}">
        <td class="py-2">
          {{ item._relaciones.ubicacion_raiz.payload.nombre }}
        </td>
      </template>
      <template #actividad_id="{item}">
        <td class="py-2">
          {{ item._relaciones.actividad.payload.nombre }}
        </td>
      </template>
      <template #trabajador_id="{item}">
        <td class="py-2">
          {{ item._relaciones.trabajador.payload.nombre }}
        </td>
      </template>
      <template #cantidad_costo="{item}">
        <td class="py-2 text-right">
          {{ $formatter(item.cantidad_costo, 0, ".00") }}
        </td>
      </template>
      <template #monto="{item}">
        <td class="py-2 text-right">
          {{ $formatter(item.monto, 1) }}
        </td>
      </template>
      <template #costo_unitario="{item}">
        <td class="py-2 text-right">
          {{ $formatter(item.costo_unitario, 1) }}
        </td>
      </template>
      <template #total="{item}">
        <td class="py-2 text-right">
          {{ $formatter(item.cantidad_costo * item.costo_unitario, 1) }}
        </td>
      </template>
      <template #data="{item}">
        <td class="py-2">
          {{ Object.keys(item) }}
          <br />
          {{ Object.keys(item._relaciones) }}
        </td>
      </template>

      <template #ver="{item}">
        <td class="py-2">
          <router-link
            :to="{
              name: row.view,
              params: {
                id: item.folio,
                folio: item.folio,
                goBack: {
                  name: 'VerCalculoAdministrativo',
                  params: {
                    id: folio
                  }
                }
              }
            }"
          >
            <CButton color="success" square size="sm">Ver</CButton>
          </router-link>
        </td>
      </template>

      <template #under-table>
        <div class="footer-table"></div>
      </template>
    </CDataTable>
  </div>
</template>

<script>
import DocsTranslationMixin from '../../../mixins/DocsTranslationMixin';

/*
Prestaciones

Folio | Ubicación Raíz | Actividad | Cantidad Costo | Costo Unitario | Total (Cantidad Costo por costo unitario)

Bonos aplicados

Folio | Ubicación Raíz | Concepto | Monto

Cajas aplicadas

Folio | Ubicación Raíz | Monto

Préstamos aplicados

Folio | Ubicación Raíz | Monto
*/
export default {
  name: "TableCalculoAdministrativo",
  mixins: [DocsTranslationMixin],
  data() {
    return {
      isLoading: true,
      items: [],
      folio: this.$route.params.id,
    };
  },
  created() {
    this.$store
      .dispatch("customDocumentoHTTP", {
        schema: this.row.schema,
        "with-storage": ["*"],
        filter: {
          wherein: [
            {
              field: `doc_${this.row.schema}.payload->encabezado->ubicacion_raiz_id`,
              value: [this.ubicacionRaiz]
            },
            {
              field: `doc_${this.row.schema}.folio`,
              value: this.row.children.map(m => m.folio)
            }
          ]
        }
      })
      .then(res => {
        console.log(res.data);

        const items = this.row.children.map(({ folio }) => {
          return {
            folio,
            ...res.data.find(f => f.folio === folio).payload.encabezado
          };
        });
        console.log(items);
        this.items = items;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  props: {
    row: {
      type: Object,
      default: () => ({
        name: "",
        view: "",
        schema: "",
        children: []
      })
    }
  }
};
</script>

<style lang="scss" scoped></style>
